import React from 'react';

import { useMessagesContext } from '../../contexts/MessagesContext';
import { RoomType } from '../../types/api.graphql';
import SingleChatV2 from '../SingleChatV2';
import VehicleChatTopView from './VehicleChatTopView';

export interface ChatWrapperProps {
  roomType: RoomType;
  roomId?: string;
  roomData?: any;
  vehicleId?: string;
  onClose: () => void;
}

const SingleChatWrapper = ({ roomType, vehicleId, onClose, roomData }: ChatWrapperProps) => {
  const {
    createInOrgDirectMessage,
    createInOrgGeneralMessage,
    createVehicleInternalMessage,
    createOrgInviteRoomMessage,
    loadMoreMessages,
    hasMoreMessages,
    messages,
    loadingMessages,
  } = useMessagesContext();

  const chatMessages = messages?.()?.messages?.nodes;

  const sendInOrgGeneralMessage = (message: string) => {
    void (async () => {
      await createInOrgGeneralMessage(message);
    })();
  };

  const sendInviteOrgRoomlMessage = (message: string) => {
    void (async () => {
      await createOrgInviteRoomMessage(message, vehicleId);
    })();
  };

  const sendInOrgDirectMessage = (message: string) => {
    void (async () => {
      await createInOrgDirectMessage(message);
    })();
  };

  const sendVehicleInternalMessage = (message: string) => {
    void (async () => {
      await createVehicleInternalMessage(message, vehicleId);
    })();
  };

  const submitFunction = (): any => {
    switch (roomType) {
      case RoomType.InOrgGeneralRoom:
        return sendInOrgGeneralMessage;
      case RoomType.InOrgDirectRoom:
        return sendInOrgDirectMessage;
      case RoomType.ListingInternalRoom:
        return sendVehicleInternalMessage;
      case RoomType.OrgInviteRoom:
        return sendInviteOrgRoomlMessage;
    }
  };

  const createGroupHeader = () => {
    if (roomType !== RoomType.InOrgGeneralRoom) {
      return null;
    }
    return {
      name: roomData?.name || '',
      members:
        roomData?.organization?.userRoles?.map((user) => {
          return {
            member: [user.user.firstName, user.user.lastName].join(' '),
            profileImage: user.user.imageUrl,
          };
        }) || [],
    };
  };

  const createVehicleGroupHeader = () => {
    if (roomType !== RoomType.ListingInternalRoom && roomType !== RoomType.OrgInviteRoom) {
      return null;
    }
    const vehicle = roomData?.vehicle;
    return {
      title: vehicle?.displayName || [vehicle?.year, vehicle?.make, vehicle?.model].join(' '),
      organization: roomData?.name,
      submitter: 'P',
      isUserOnline: false,
      profileImage: roomData?.img,
      vehicleImage: vehicle?.pictures?.[0]?.url,
    };
  };

  return (
    <SingleChatV2
      onSubmit={submitFunction()}
      messages={chatMessages}
      loadMoreMessages={loadMoreMessages}
      hasMoreMessages={hasMoreMessages}
      loadingMessages={loadingMessages}
      onClose={onClose}
      groupHeader={createGroupHeader()}
      vehicleAndMemberHeader={createVehicleGroupHeader()}
      conversationTopView={
        roomType === RoomType.ListingInternalRoom ? <VehicleChatTopView vehicle={roomData?.vehicle} /> : undefined
      }
    />
  );
};

export default SingleChatWrapper;
